import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaUserGraduate,
  FaIndustry,
  FaTools,
  FaGraduationCap,
  FaRocket,
  FaUniversity
} from "react-icons/fa";

const CoOpSocietyPage = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    });
  }, []);

  const container = {
    maxWidth: "1200px",
    margin: "auto",
    padding: "80px 20px"
  };

  const hero = {
    background: "linear-gradient(120deg,#0f172a,#1e293b)",
    color: "white",
    textAlign: "center",
    padding: "120px 20px"
  };

  const grid = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: "25px",
    marginTop: "40px"
  };

  const card = {
    background: "white",
    padding: "25px",
    borderRadius: "10px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    textAlign: "center"
  };

  const highlight = {
    background: "#f1f5f9",
    borderLeft: "6px solid #2563eb",
    padding: "40px",
    borderRadius: "8px"
  };

  const stepBox = {
    flex: "1",
    minWidth: "150px",
    textAlign: "center",
    background: "white",
    padding: "25px",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.08)"
  };

  const primaryBtn = {
    background: "#2563eb",
    color: "white",
    padding: "12px 28px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    margin: "10px"
  };

  const secondaryBtn = {
    background: "white",
    padding: "12px 28px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    margin: "10px"
  };

  const cta = {
    background: "#1e293b",
    color: "white",
    textAlign: "center",
    padding: "80px 20px",
    marginTop: "60px"
  };

  return (
    <div>

      {/* HERO */}
      <section style={hero}>
        <h1 style={{ fontSize: "48px", marginBottom: "20px" }}>
          Drone Tech Multi-State Co-operative Society Limited
        </h1>

        <p style={{ fontSize: "18px", maxWidth: "700px", margin: "auto" }}>
          Building the Cooperative Power of India’s Drone Ecosystem.
          A collaborative platform uniting pilots, manufacturers,
          students and institutions to participate in the future of
          drone technology.
        </p>

        <div style={{ marginTop: "30px" }}>
          <button style={primaryBtn}>Apply for Membership</button>
          <button style={secondaryBtn}>Explore Ecosystem</button>
        </div>
      </section>

      {/* ABOUT */}
      <section style={container} data-aos="fade-up">

        <h2>About the Society</h2>

        <p>
          Drone Tech Multi-State Co-operative Society Limited has been
          established to create a collaborative ecosystem for the drone
          sector across Haryana, Rajasthan and Uttar Pradesh.
        </p>

      </section>

      {/* WHO CAN JOIN */}
      <section style={container} data-aos="fade-up">

        <h2>Who Can Join</h2>

        <div style={grid}>

          <div style={card}>
            <FaTools size={32}/>
            <h3>Drone Pilots</h3>
          </div>

          <div style={card}>
            <FaIndustry size={32}/>
            <h3>Manufacturers</h3>
          </div>

          <div style={card}>
            <FaTools size={32}/>
            <h3>Technicians</h3>
          </div>

          <div style={card}>
            <FaGraduationCap size={32}/>
            <h3>Students</h3>
          </div>

          <div style={card}>
            <FaRocket size={32}/>
            <h3>Startups</h3>
          </div>

          <div style={card}>
            <FaUniversity size={32}/>
            <h3>Institutions</h3>
          </div>

        </div>

      </section>

      {/* MEMBERSHIP CATEGORIES */}
      <section style={container} data-aos="fade-up">

        <h2>Membership Categories</h2>

        <div style={grid}>

          <div style={card}>
            <h3>Individual Member</h3>
            <p>Students and individuals interested in the drone ecosystem.</p>
          </div>

          <div style={card}>
            <h3>Professional Member</h3>
            <p>Pilots, trainers and technicians.</p>
          </div>

          <div style={card}>
            <h3>Enterprise Member</h3>
            <p>Drone companies, startups and manufacturers.</p>
          </div>

          <div style={card}>
            <h3>Institutional Member</h3>
            <p>Universities and training institutes.</p>
          </div>

        </div>

      </section>

      {/* JV SECTION */}
      <section style={container} data-aos="fade-up">

        <div style={highlight}>

          <h2>Strategic Joint Venture with AVPL International</h2>

          <p>
            The Society has secured a 10% stake in the physical portal
            of Drone Planet through the Drone City Haryana ecosystem.
          </p>

          <ul>
            <li>Institutional ecosystem participation</li>
            <li>Connection with real drone infrastructure</li>
            <li>Long-term ecosystem value creation</li>
          </ul>

        </div>

      </section>

      {/* MEMBERSHIP PROCESS */}
      <section style={container} data-aos="fade-up">

        <h2>Membership Process</h2>

        <div style={{display:"flex",gap:"20px",flexWrap:"wrap",marginTop:"40px"}}>

          <div style={stepBox}>
            <h3>1</h3>
            <p>Submit Application</p>
          </div>

          <div style={stepBox}>
            <h3>2</h3>
            <p>Verification</p>
          </div>

          <div style={stepBox}>
            <h3>3</h3>
            <p>Approval</p>
          </div>

          <div style={stepBox}>
            <h3>4</h3>
            <p>Member Onboarding</p>
          </div>

        </div>

      </section>

      {/* CTA */}
      <section style={cta}>

        <h2>Join the Cooperative Powering the Future of Drone Technology</h2>

        <p style={{maxWidth:"600px",margin:"20px auto"}}>
          Become part of a growing ecosystem connecting people,
          technology, infrastructure and opportunity.
        </p>

        <button style={primaryBtn}>
          Apply for Membership
        </button>

      </section>

    </div>
  );
};

export default CoOpSocietyPage;